export const ALL_SEASONS = 'all';

export const isFootballLabel = (label) => /voetbal|football|eredivisie|eerste divisie|keuken kampioen|knvb|beker|champions league|europa league|conference league/i.test(label || '');

export const isFootballMatch = (match) => {
  if (typeof match?.isFootballMatch === 'boolean') return match.isFootballMatch;
  if (match?.isGathering || match?.starts_at) return isFootballLabel(match.label);
  return !!match && !/Locatie: |training|teamavond|borrel|bijeenkomst/i.test(match.label || '');
};

export const getMatchIds = (match) => match ? [...new Set([match.id, ...(match.matchIds || [])].filter(Boolean))] : [];

export const getLatestGathering = (matches = [], transactions = [], now = new Date()) => {
  const tomorrow = new Date(now);
  tomorrow.setHours(0, 0, 0, 0);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const available = matches.filter((match) => match.status !== 'cancelled' && new Date(match.date || match.starts_at) < tomorrow)
    .sort((a, b) => new Date(b.date || b.starts_at) - new Date(a.date || a.starts_at));
  const orderedIds = new Set(transactions.map((transaction) => transaction.match_id));
  return available.find((match) => getMatchIds(match).some((id) => orderedIds.has(id))) || available[0] || null;
};

export const getMatchSeasonKey = (match) => {
  if (!isFootballMatch(match)) return null;
  const explicit = String(match.season || '').replace('/', '-');
  return /^\d{4}-\d{4}$/.test(explicit) ? explicit : getSeasonKeyFromDate(match.date || match.starts_at);
};

export const getSeasonKeyFromDate = (value) => {
  const date = value instanceof Date ? value : new Date(value);
  if (!value || Number.isNaN(date.getTime())) return null;
  const year = date.getFullYear();
  const seasonStart = date.getMonth() >= 6 ? year : year - 1;
  return `${seasonStart}-${seasonStart + 1}`;
};

export const formatSeasonLabel = (seasonKey) => {
  if (!seasonKey || seasonKey === ALL_SEASONS) return 'All-time';
  const [start, end] = String(seasonKey).split('-');
  return start && end ? `${start}/${end}` : seasonKey;
};

export const formatSeasonShortLabel = (seasonKey) => {
  if (!seasonKey || seasonKey === ALL_SEASONS) return 'All';
  const [start, end] = String(seasonKey).split('-');
  return start && end ? `${start.slice(-2)}/${end.slice(-2)}` : seasonKey;
};

export const getCurrentSeasonKey = (now = new Date()) => getSeasonKeyFromDate(now);

export const getSeasonOptionsFromMatches = (matches = [], includeCurrent = true) => {
  const seasonSet = new Set();
  for (const match of matches || []) {
    const key = getMatchSeasonKey(match);
    if (key) seasonSet.add(key);
  }
  if (includeCurrent && (matches || []).some(isFootballMatch)) {
    const current = getCurrentSeasonKey();
    if (current) seasonSet.add(current);
  }
  return Array.from(seasonSet).sort((a, b) => b.localeCompare(a));
};

export const buildMatchSeasonMap = (matches = []) => {
  const map = new Map();
  for (const match of matches || []) {
    const key = getMatchSeasonKey(match);
    if (key) getMatchIds(match).forEach((id) => map.set(id, key));
  }
  return map;
};

export const filterTransactionsBySeason = (transactions = [], matches = [], seasonKey = ALL_SEASONS) => {
  if (!seasonKey || seasonKey === ALL_SEASONS) return transactions || [];
  const matchSeasonMap = buildMatchSeasonMap(matches);
  return (transactions || []).filter((tx) => tx?.match_id && matchSeasonMap.get(tx.match_id) === seasonKey);
};
